export default {
    vehicleTypes: [],
    vendorCategories: [],
    addressTypes: [],
    platformBoundaries: [],
    branches: [],
    vendorClassification: [],
    data: [],
    total: {
        totalItems: 5,
        totalPages: 5,
    },

    simpleDetail: {},

};
